import {
  getRoutesList,
} from "actions/Catalogs";
import Grid from "components/Grid";
import RouteModal from "components/RoutesModal";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

const Routes = () => {
  const [t] = useTranslation("catalog");
  const [tg] = useTranslation("global");
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = React.useState(false);
  const { currentProject } = useSelector((state) => state.auth);
  const { routesList } = useSelector((state) => state.catalog);
  const [route, setRoute] = React.useState();
  useEffect(() => {
    if (currentProject && currentProject?.id) {
      dispatch(getRoutesList(currentProject.id));
    }
  }, [dispatch, currentProject]);

  return (
    <>
      <Grid
        title={t("route.title")}
        columns={[
          {
            Header: "Id",
            accessor: "id",
            filter: "text",
            width: "10%",
          },
          {
            Header: t("route.code_route"),
            accessor: "routeCode",
            filter: "text",
            width: "18%",
          },
          {
            Header: t("route.route"),
            accessor: "route",
            filter: "text",
            width: "18%",
          },
          {
            Header: t("route.destinations_length"),
            accessor: "destinations",
            filter: "text",
            width: "18%",
            Cell: ({ value }) => {
              return value.length;
            },
          },
          {
            Header: t("route.status"),
            accessor: "status",
            filter: "text",
            width: "18%",
            Cell: ({ value }) => {
              return value ? tg("select.active") : tg("select.inactive");
            },
          },
        ]}
        data={routesList || []}
        handleAdd={() => {
          setRoute(null);
          setOpenModal(true);
        }}
        handleEdit={(row) => {
          setRoute(row);
          setOpenModal(true);
        }}
        write={true}
      />
      {openModal ? (
        <RouteModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          route={route}
        />
      ) : null}
    </>
  );
};

export default Routes;